/**
 * Event lifecycle for clients/admin, derived from event date(s) - not stored on the booking.
 */

/** @param {object} booking */
export const getLastEventDate = (booking) => {
  if (!booking) return null;
  if (booking.eventType === 'multi-day' && booking.dayLocations && booking.dayLocations.length > 0) {
    const dates = booking.dayLocations
      .map((day) => day.date)
      .filter(Boolean)
      .map((d) => new Date(d))
      .filter((d) => !Number.isNaN(d.getTime()));
    return dates.length > 0 ? new Date(Math.max(...dates.map((d) => d.getTime()))) : null;
  }
  if (booking.eventDate) {
    const d = new Date(booking.eventDate);
    return !Number.isNaN(d.getTime()) ? d : null;
  }
  return null;
};

const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

/**
 * @param {object} booking
 * @returns {{ key: string, label: string, description: string }}
 */
export const getClientEventStatus = (booking) => {
  const last = getLastEventDate(booking);
  if (!last) {
    return {
      key: 'date_tbd',
      label: 'Date to be confirmed',
      description: 'Your event date is not set yet. We will update this once confirmed.'
    };
  }
  const eventDay = startOfDay(last);
  const today = startOfDay(new Date());
  if (eventDay > today) {
    return {
      key: 'upcoming',
      label: 'Upcoming',
      description: 'Your wedding day is still ahead. We will begin post-production after the event.'
    };
  }
  if (eventDay.getTime() === today.getTime()) {
    return {
      key: 'event_day',
      label: 'Event day',
      description: 'Today is your event. We hope you have a wonderful celebration.'
    };
  }
  return {
    key: 'post_event',
    label: 'Post-event',
    description: 'Your event has passed. Editing and delivery follow our usual timeline from here.'
  };
};
